import { render, staticRenderFns } from "./AllEmployers.vue?vue&type=template&id=f4dcaeb0&scoped=true&"
import script from "./AllEmployers.vue?vue&type=script&lang=js&"
export * from "./AllEmployers.vue?vue&type=script&lang=js&"
import style0 from "./AllEmployers.vue?vue&type=style&index=0&id=f4dcaeb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dcaeb0",
  null
  
)

export default component.exports